var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemo43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 30,
    viewBox: "0 0 145 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8672 22.5004H52.7697L53.4447 13.5679C53.5122 12.5104 53.4672 11.0704 53.4672 11.0704H53.5122C53.5122 11.0704 54.0069 12.6454 54.3894 13.5679L56.9544 19.7554H59.4969L62.0844 13.5679C62.4669 12.6454 62.9394 11.0929 62.9394 11.0929H62.9844C62.9844 11.0929 62.9394 12.5104 63.0069 13.5679L63.6819 22.5004H66.5619L65.2794 6.52539H62.1744L59.0469 14.4229C58.6869 15.3679 58.2594 16.7629 58.2594 16.7629H58.2144C58.2144 16.7629 57.7644 15.3679 57.4044 14.4229L54.2769 6.52539H51.1722L49.8672 22.5004ZM68.8558 16.7629C68.8558 20.0254 71.2183 22.7704 75.0208 22.7704C77.8783 22.7704 79.6333 21.1279 79.6333 21.1279L78.5308 19.0804C78.5308 19.0804 77.0683 20.3404 75.2233 20.3404C73.5133 20.3404 71.9608 19.3054 71.7808 17.3029H79.7008C79.7008 17.3029 79.7683 16.5379 79.7683 16.2004C79.7683 13.1629 77.9908 10.7554 74.6833 10.7554C71.2633 10.7554 68.8558 13.2304 68.8558 16.7629ZM71.8708 15.3454C72.1408 13.8604 73.1533 12.9604 74.6158 12.9604C75.8758 12.9604 76.8433 13.7929 76.8883 15.3454H71.8708ZM82.6189 18.2929C82.6189 22.1404 85.7914 22.6129 87.3889 22.6129C87.9289 22.6129 88.2664 22.5454 88.2664 22.5454V20.0479C88.2664 20.0479 88.0639 20.0929 87.7489 20.0929C86.9614 20.0929 85.4764 19.8229 85.4764 17.9329V13.4779H88.0864V11.2054H85.4764V7.89789H82.6864V11.2054H81.1339V13.4779H82.6189V18.2929ZM90.6053 22.5004H93.4628V17.9554C93.4628 17.2804 93.5303 16.6504 93.7103 16.0879C94.2503 14.3779 95.6228 13.6804 96.8378 13.6804C97.2203 13.6804 97.5128 13.7254 97.5128 13.7254V10.9129C97.5128 10.9129 97.2653 10.8679 96.9953 10.8679C95.2403 10.8679 93.8678 12.1729 93.3503 13.8154H93.3053C93.3053 13.8154 93.3503 13.4329 93.3503 13.0054V11.0254H90.6053V22.5004ZM98.5837 16.7629C98.5837 20.2954 101.396 22.7704 104.906 22.7704C108.394 22.7704 111.206 20.2954 111.206 16.7629C111.206 13.2529 108.394 10.7554 104.884 10.7554C101.396 10.7554 98.5837 13.2529 98.5837 16.7629ZM101.486 16.7629C101.486 14.6479 103.039 13.1854 104.906 13.1854C106.751 13.1854 108.304 14.6479 108.304 16.7629C108.304 18.9004 106.751 20.3404 104.906 20.3404C103.039 20.3404 101.486 18.9004 101.486 16.7629ZM113.501 22.5004H116.359V17.2354C116.359 16.6954 116.404 16.1779 116.561 15.7054C116.989 14.3329 118.114 13.3654 119.644 13.3654C121.106 13.3654 121.466 14.3104 121.466 15.7054V22.5004H124.301V15.1204C124.301 12.0829 122.861 10.7554 120.319 10.7554C118.001 10.7554 116.741 12.1729 116.246 13.1404H116.201C116.201 13.1404 116.246 12.7804 116.246 12.3529V11.0254H113.501V22.5004ZM127.3 9.06789H130.135V6.52539H127.3V9.06789ZM127.3 22.5004H130.158V11.0254H127.3V22.5004ZM132.466 16.7629C132.466 20.0929 134.896 22.7704 138.698 22.7704C141.781 22.7704 143.423 20.9029 143.423 20.9029L142.321 18.8779C142.321 18.8779 140.881 20.3404 138.946 20.3404C136.763 20.3404 135.369 18.6754 135.369 16.7404C135.369 14.7829 136.741 13.1854 138.856 13.1854C140.656 13.1854 141.848 14.4229 141.848 14.4229L143.108 12.4654C143.108 12.4654 141.691 10.7554 138.698 10.7554C134.896 10.7554 132.466 13.5004 132.466 16.7629Z",
    fill: "#181C32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7393 1.4876L40.8867 26.8556C41.3309 28.2387 40.2992 29.6537 38.8465 29.6537H32.8554C31.9218 29.6537 31.0956 29.0492 30.813 28.1593L22.7583 2.79135C22.3195 1.40958 23.3509 0 24.8006 0H30.6991C31.6301 0 32.4546 0.601173 32.7393 1.4876Z",
    fill: "#7239EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_13825_6679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9367 20.25L19.1916 1.84778C18.8484 0.748548 17.8305 0 16.679 0C15.2773 0 14.1215 1.09841 14.0502 2.49826L13.3493 16.2531C13.3244 16.7417 13.3834 17.2309 13.5236 17.6995L16.6423 28.1249C16.9137 29.0322 17.7483 29.6537 18.6952 29.6537H21.5943C22.5269 29.6537 23.3525 29.0504 23.6359 28.1618L24.925 24.1186C25.326 22.8609 25.3301 21.5102 24.9367 20.25Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9367 20.25L19.1916 1.84778C18.8484 0.748548 17.8305 0 16.679 0C15.2773 0 14.1215 1.09841 14.0502 2.49826L13.3493 16.2531C13.3244 16.7417 13.3834 17.2309 13.5236 17.6995L16.6423 28.1249C16.9137 29.0322 17.7483 29.6537 18.6952 29.6537H21.5943C22.5269 29.6537 23.3525 29.0504 23.6359 28.1618L24.925 24.1186C25.326 22.8609 25.3301 21.5102 24.9367 20.25Z",
    fill: "url(#paint0_linear_13825_6679)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8839 0H16.7845C18.2295 0 19.2602 1.40083 18.8304 2.78033L10.8584 28.3647C10.5794 29.2602 9.7505 29.8701 8.81257 29.8701H2.91192C1.467 29.8701 0.436238 28.4693 0.866082 27.0898L8.83801 1.50538C9.11707 0.609943 9.94598 0 10.8839 0Z",
    fill: "#7239EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13825_6679",
    x: 9.34375,
    y: 0,
    width: 15.8848,
    height: 32.6533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.904167 0 0 0 0 0.892865 0 0 0 0 0.892865 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13825_6679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13825_6679",
    x1: 15.5357,
    y1: 13.125,
    x2: 26.25,
    y2: 16.3393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo43);
export default __webpack_public_path__ + "static/media/demo43.34d4a8175fb279f9c04e870ed946763d.svg";
export { ForwardRef as ReactComponent };